export const uiTranslations = {
  en: {
    nav: {
      about: 'About',
      conductor: 'Director',
      members: 'Members',
      videos: 'Works',
      performances: 'Events',
      contact: 'Contact',
    },
    common: {
      join: 'Join',
      loading: 'Loading content...',
      error: 'An error occurred',
      loadError: 'Failed to load content. Please try again later.',
      backToHome: 'Back to Home',
      pageNotFound: 'Page Not Found',
      visitChannel: 'Visit Channel',
      moreInfoComingSoon: 'More performance info coming soon.',
      joinQrCode: 'Join QR Code',
      scanToJoin: 'Scan to join the choir',
      toggleTheme: 'Toggle theme',
    },
    sections: {
      about: 'About Us',
      conductor: 'Artistic Director',
      members: 'Members',
      videos: 'Works',
      performances: 'Performances',
      contact: 'Contact & Collaboration',
    },
    contact: {
      contactInfo: 'Contact Info',
      followUs: 'Follow Us',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      website: 'Website',
      defaultIntro: 'If you are interested in our performances, or want to join us, please feel free to contact us. We look forward to sharing the beauty of music with you.',
      followOn: 'Follow us on {platform}',
    },
    footer: {
      quickLinks: 'Quick Links',
      rehearsalTime: 'Rehearsal Time',
      madeWithCare: 'Made with care',
    }
  },
  zh: {
    nav: {
      about: '关于我们',
      conductor: '指挥介绍',
      members: '团员风采',
      videos: '作品展示',
      performances: '演出',
      contact: '联系与合作',
    },
    common: {
      join: '加入',
      loading: '正在加载内容...',
      error: '发生错误',
      loadError: '内容加载失败，请稍后再试。',
      backToHome: '返回首页',
      pageNotFound: '页面不存在或已移除',
      visitChannel: '访问频道',
      moreInfoComingSoon: '敬请期待更多演出信息。',
      joinQrCode: '报名二维码',
      scanToJoin: '扫码报名加入合唱团',
      toggleTheme: '切换主题',
    },
    sections: {
      about: '关于我们',
      conductor: '指挥介绍',
      members: '团员风采',
      videos: '作品展示',
      performances: '演出风采',
      contact: '联系与合作',
    },
    contact: {
      contactInfo: '联系信息',
      followUs: '关注我们',
      email: '邮箱',
      phone: '电话',
      address: '地址',
      website: '官网',
      defaultIntro: '如果您对我们的演出感兴趣，或者想要加入我们，请随时与我们联系。我们期待与您分享音乐的美好。',
      followOn: '在 {platform} 上关注我们',
    },
    footer: {
      quickLinks: '快速链接',
      rehearsalTime: '排练时间',
      madeWithCare: '用心制作',
    }
  }
};
